import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { mediaBreakpointDown } from 'styles/grid';

const stepsMobileBreakpoint = mediaBreakpointDown.sm;

export const StepContainer = styled.div`
  margin: 24px auto 0 auto;
  max-width: 520px;
  ${stepsMobileBreakpoint} {
    padding: 0 10px 0 10px;
  }
`;

export const StepContainerFullHeight = styled.div`
  height: 100%;
  max-width: 520px;
  margin: auto;
  ${stepsMobileBreakpoint} {
    padding: 24px 10px;
  }
`;

export const TrackingTimelineContainer = styled.div`
  margin: 16px 32px;
`;
